<template>
  <VAppBar
    color="white"
    app
    absolute
    elevation="0"
    class="landing-header"
    :height="$vuetify.breakpoint.mdAndUp ? 95 : undefined"
  >
    <VContainer class="py-0">
      <slot />
      <div class="d-flex justify-space-between align-center">
        <a :href="`https://${HOME_DOMAIN}`">
          <img
            class="d-none d-sm-block"
            src="@/assets/img/logo-landing.svg"
            width="162"
            height="27"
            alt="Huntica"
          >
          <img
            class="d-sm-none"
            src="@/assets/img/logo-landing-mobile.svg"
            width="35"
            height="31"
            alt="Huntica"
          >
        </a>
        <div class="d-flex justify-end  align-center">
          <!--<LandingTopMenu />-->
          <LanguageSelect color="white" />
          <a :href="loginLink" class="landing-header__login" @click.stop>
            <span>
              {{ $t('signIn') }}
            </span>
            <svg class="login-icon" viewBox="0 0 24 31" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.6465 21.4587C10.451 21.6644 10.451 21.997 10.6465 22.2027C10.744 22.3053 10.872 22.3569 11 22.3569C11.128 22.3569 11.256 22.3053 11.3535 22.2027L17.353 15.8887C17.3995 15.8403 17.436 15.7819 17.4615 15.7172C17.512 15.5888 17.512 15.4441 17.4615 15.3152C17.436 15.2504 17.399 15.192 17.353 15.1431L11.3535 8.8296C11.158 8.62386 10.842 8.62386 10.6465 8.8296C10.451 9.03535 10.451 9.36792 10.6465 9.57367L15.793 14.99H0.5C0.2235 14.99 0 15.2252 0 15.5162C0 15.8072 0.2235 16.0424 0.5 16.0424H15.793L10.6465 21.4587Z" fill="white" /><path d="M23.5 0.782227H5C4.7235 0.782227 4.5 1.01744 4.5 1.30844V12.3589C4.5 12.6499 4.7235 12.8851 5 12.8851C5.2765 12.8851 5.5 12.6499 5.5 12.3589V1.83465H23V29.1976H5.5V18.6734C5.5 18.3824 5.2765 18.1472 5 18.1472C4.7235 18.1472 4.5 18.3824 4.5 18.6734V29.7238C4.5 30.0148 4.7235 30.25 5 30.25H23.5C23.7765 30.25 24 30.0148 24 29.7238V1.30844C24 1.01744 23.7765 0.782227 23.5 0.782227Z" fill="white" /></svg>
          </a>
        </div>
      </div>
    </VContainer>
  </VAppBar>
</template>

<script>
import { HOME_DOMAIN } from '@/helpers/constants';
import useUtm from '@/compositions/useUtm';
import LanguageSelect from '../LanguageSelect.vue';
import { cabinetUrl } from '../../functions';

export default {
  name: 'LandingHeader',
  components: {
    LanguageSelect,
  },
  setup(_, { root }) {
    const { referralCode } = root.$route.query;
    const { getUtm } = useUtm();
    const loginLink = referralCode ? cabinetUrl(`login?referralCode=${referralCode}`)
      : cabinetUrl(`login?${new URLSearchParams(getUtm()).toString()}`);

    return {
      loginLink,
      HOME_DOMAIN,
    };
  },
};
</script>
<style lang="scss">
  .landing-header {
    .v-toolbar__content {
      padding: 0;
      z-index: 2;
    }
  }
</style>
<style scoped lang="scss">
  @keyframes blink {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
  .animate-blink {
    animation: blink 2000ms cubic-bezier(0, 0, 0.2, 1) infinite;
  }
  .landing-header {
    background: transparent !important;
    &:before {
      content: '';
      position: absolute;
      height: 8px;
      width: 100%;
      left: 0;
      bottom: 0;
      // box-shadow: 0 4px 4px rgba(0, 0, 0, 0.15);
      z-index: 1;
    }
    &__login {
      display: inline-flex;
      align-items: center;
      font-size: 16px;
      text-transform: none;
      font-weight: 500;
      padding: 0;
      cursor: pointer;
      text-decoration: none;
      color: #fff;

      .login-icon {
        width: 13px;
        height: 18px;
      }
    }
  }
  @media #{map-get($display-breakpoints, 'sm-and-up')} {
    .landing-header {
      position: absolute;
      &:before {
        display: none;
      }

      &__login {

        .login-icon {
          width: 16px;
          height: 22px;
          margin-left: 17px;
        }
      }
    }
  }
</style>

<i18n locale="en" lang="yaml">
  signIn: Sign in
</i18n>

<i18n locale="ru" lang="yaml">
  signIn: Войти
</i18n>
